import type { IRealtimeService } from './IRealtimeService';
import type { WebsocketMessage } from '@playcastdotio/Messaging';
import { isSensitiveMessage } from '@playcastdotio/Messaging';
import * as realtimeConnection from './RealtimeConnection';
import { attachSentryTraceToMessage } from '../../api/modules/realtime/tracing';

export interface RealtimeConnectionPort {
  sendMessage(message: WebsocketMessage): void;
  trySendMessage(message: WebsocketMessage): boolean;
  isConnectionReady(): boolean;
  onConnected(listener: () => void): () => void;
  onDisconnected(listener: () => void): () => void;
  onHostAuthSuccess(listener: () => void): () => void;
}

/** Production adapter; socket ownership and queue policy stay in the connection service. */
export class RealRealtimeService implements IRealtimeService {
  constructor(private readonly connection: RealtimeConnectionPort = realtimeConnection) {}
  sendMessage(message: WebsocketMessage): void {
    const traced = isSensitiveMessage(message) ? message : attachSentryTraceToMessage(message);
    this.connection.sendMessage(traced);
  }
  trySendMessage(message: WebsocketMessage): boolean { return this.connection.trySendMessage(message); }
  isConnected(): boolean { return this.connection.isConnectionReady(); }
  onConnected(listener: () => void): () => void { return this.connection.onConnected(listener); }
  onDisconnected(listener: () => void): () => void { return this.connection.onDisconnected(listener); }
  onHostAuthSuccess(listener: () => void): () => void { return this.connection.onHostAuthSuccess(listener); }
}
